export type ApiError = Error & { status?: number; detail?: any };

const API_BASE = process.env.NEXT_PUBLIC_API_BASE_URL || "";

const buildUrl = (path: string) => {
  if (path.startsWith("http")) return path;
  return `${API_BASE}${path}`;
};

type ApiFetchInit = Omit<RequestInit, "body" | "headers"> & {
  body?: any;
  headers?: HeadersInit;
};

export async function apiFetch(path: string, init: ApiFetchInit = {}) {
  const url = buildUrl(path);
  const headers = new Headers(init.headers || {});
  const isFormData = init.body instanceof FormData;
  if (!headers.has("Content-Type") && !isFormData) {
    headers.set("Content-Type", "application/json");
  }

  let body: BodyInit | undefined = init.body as any;
  if (body && typeof body === "object" && !isFormData && !(body instanceof Blob) && !(body instanceof ArrayBuffer)) {
    body = JSON.stringify(body);
  }

  const res = await fetch(url, {
    credentials: "include",
    ...init,
    headers,
    body,
  });

  let data: any = null;
  const text = await res.text();
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text || null;
  }

  if (!res.ok) {
    const err: ApiError = new Error((data && data.detail) || `HTTP ${res.status}`);
    err.status = res.status;
    err.detail = data?.detail;
    throw err;
  }

  return data;
}

export function apiUrl(path: string) {
  return buildUrl(path);
}
